import GetEventDetailAdmin from "./GetEvent.jsx/GetEventDetailsAdmin"
import { FormProvider } from './FormContextAdmin'
import { Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { EVENT_VISIBLE_TO_USER } from './ApiDetails.js';
import EventDenied from "./GetEvent.jsx/EventDenied"
import GetEventDetail from "./GetEvent.jsx/GetEventDetail"

function GetDetailAdmin() {
  const location = useLocation();
  const eventId = location.pathname.split('/').pop();
  var role = localStorage.getItem('role');

  const [eventIsVisible, setEventIsVisible] = useState(false);
  const [eventStatus, setEventStatus] = useState("");
  const [userIsEventRequestor, setUserIsEventRequestor] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [secuOK, setSecuOK] = useState(false);
  
  const getIsEventVisible = async (eventID) => {
        await axios.get(`${EVENT_VISIBLE_TO_USER}/${eventID}`)
          .then(response => {
              var data = response.data;
              if (data != null) {
                  setEventStatus(data.status);
                  setEventIsVisible(data.visible);
                  setSecuOK(true);
                  setUserIsEventRequestor(data.userIsEventRequestor);
              }
          })
          .catch(error => {
              console.error('Error reading event : ', error);
          });
  }

  useEffect(() => {
      if (isFirstLoad) {
          getIsEventVisible(eventId);
          setIsFirstLoad(false);
      }
 }, []);

  //const renderPage = () => {
  if (!secuOK) {
      return "";
  } else
  if (!eventIsVisible) {
    if (eventStatus==="deleted")
      return (<div><Navigate to="/" replace /></div>)
    else
      return (<FormProvider><EventDenied /></FormProvider>)
  }
  else
  switch (role) {
    case 'Visit Requester':
    case 'Requester':
      return (
        <div>
          <Navigate to={`/getDetail/${eventId}`} replace />
        </div>
      )
    case 'MLTUser':
    case 'MLTCoordinator':
      return (
        <div>
          <Navigate to={`/GetDetailEventMlt/${eventId}`} replace />
        </div>
      )
    case 'Admin':
      return (
        <FormProvider>
          <GetEventDetailAdmin />
        </FormProvider>
      )
    case 'Family':
    case 'FamilyCoordinator':
      if (((eventStatus==="Draft") || (eventStatus==="Under review")) && eventIsVisible)
      return (
        <FormProvider>
          <GetEventDetail />
        </FormProvider>
      )
      else
      return (
        <div>
          <Navigate to={`/getDetailMarsComplete/${eventId}`} replace />
        </div>
      )
    default:
      return (
        <div>
          <Navigate to="/" replace />
        </div>
      )
  }
}

export default GetDetailAdmin;